import {
	MODULE_NAME,
	BASE_API,
	APIS,
	SET_APIS,
	SET_INTEGRATIONS_APIS,
	TOAST_MESSAGES_PUSH
} from './apis-mutation-types';

import { ApiService as api } from '@/services/axiosHelper';

let messageObj = {
	statusCode: 400,
	message: 'An error occurred. Please try again.'
};

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: MODULE_NAME,
	namespaced: true,
	state: {
		[APIS]: {}
	},
	mutations: {
		[SET_APIS](state, obj) {
			state[APIS] = obj;
		}
	},
	actions: {
		async [SET_APIS]({ commit, dispatch }, parameters) {
			const path = `/${BASE_API}`;
			await api
				.get(path, parameters)
				.then(resp => {
					commit(SET_APIS, resp);
				})
				.catch(error => {
					if (error) {
						messageObj.message = error;
						dispatch(TOAST_MESSAGES_PUSH, messageObj, {
							root: true
						});
					}
				});
		},
		async [SET_INTEGRATIONS_APIS](
			{ commit, dispatch },
			{ agregatorIntegratorId, id }
		) {
			const path = `/${BASE_API}/integrators/${agregatorIntegratorId}/integrations/${id}`;
			await api
				.get(path)
				.then(resp => {
					commit(SET_APIS, resp);
				})
				.catch(error => {
					if (error) {
						messageObj.message = error;
						dispatch(TOAST_MESSAGES_PUSH, messageObj, {
							root: true
						});
					}
				});
		}
	},
	getters: {
		[APIS]: state => state[APIS]
	}
};
